import { useState } from 'react';

import { MessageComposer } from '@gasbi/shared/common/components/Chat';

import type { AgentChat } from '@/features/agents/useAgentChat';

import { Stack, Typography } from '@mui/joy';

type ChatComposerProps = {
  chat: AgentChat;
  placeholder: string;
  hint: string;
};

const ErrorLine = ({ text }: { text: string }) => (
  <Typography level='body-sm' color='danger' role='alert'>
    {text}
  </Typography>
);

/**
 * What went wrong with the last message, then the composer. An external server of the agent that is not connected
 * is only reported: in this app nobody connects servers, the administrator does it once in the catalog (§2.10).
 */
export const ChatComposer = ({
  chat,
  placeholder,
  hint,
}: ChatComposerProps) => {
  const [draft, setDraft] = useState('');
  const { turn } = chat;
  const canWrite = !!chat.conversationId || !!chat.agent;

  const submit = () => {
    const text = draft;
    setDraft('');
    void chat.send(text);
  };

  return (
    <Stack gap={1}>
      {chat.startError && <ErrorLine text={chat.startError} />}
      {turn.error && <ErrorLine text={turn.error.message} />}
      {turn.connectionsRequired.map(({ serverId, server }) => (
        <ErrorLine
          key={serverId}
          text={`Сервер ${server} не підключено — зверніться до адміністратора`}
        />
      ))}
      <MessageComposer
        value={draft}
        onChange={setDraft}
        onSend={submit}
        onCancel={turn.cancel}
        streaming={turn.isStreaming}
        disabled={!canWrite}
        placeholder={placeholder}
        hint={hint}
      />
    </Stack>
  );
};
